import DatePicker from 'components/interaction/DatePicker/index.jsx';
import { isDate, isFuture } from 'utils/date-fns/index.js';

function validate(current) {
  return isDate(current) && isFuture(current);
}

const schema = {
  id: 'post',
  icons: true,
  properties: [
    {
      id: 'scheduled',
      as: DatePicker,
      attributes: { minDate: new Date(), showTimeSelect: true },
      validate,
      icon: 'ss-calendar',
    },
  ],
};

export default schema;
